module.exports = __webpack_public_path__ + "img/purple-ribbon.81354ba2.svg";